import { createFileRoute } from "@tanstack/react-router";

import SongsCreateUpdate from "@/features/songs/SongsCreateUpdate";
import SideNavLayout from "@/layouts/SideNavLayout";
import { SongsMenu } from "@/layouts/SubSideNavMenus";

export const Route = createFileRoute("/_auth/songs/create")({
  component: () => (
    <SideNavLayout menu={<SongsMenu />}>
      <SongsCreateUpdate key="create" />
    </SideNavLayout>
  ),
});
